import styled from "styled-components";

export const ButtonStyled = styled.button`
   border: none;
   height: auto;
   padding: 10px 70px;
   font-weight: bold;
   background-color:#356599;
   color: #fff;
   font-size: 16px;
   cursor: pointer;
   border-radius: 13px;
   font-family: "Red Hat Display", Sans-serif !important;

   box-shadow: 0 8px 10px #D6EAF8;
   transition: all 0.25s ease;
   &:disabled {
   background-color:rgb(164, 205, 248); 
      color: #356599;
      cursor: not-allowed;
      opacity: 0.7;
      transform: scale(1)
   }
`